import { LogManager } from '@src/utility/Logger';
import axios from 'axios';

const logger = LogManager.getLogger('service:GpuWarmupService');

/**
 * Fire-and-forget service to pre-warm GPU instances before video upload.
 * GPU instances take ~2-3 minutes to cold-start; calling this early in the
 * upload flow lets them boot while the user is uploading / filling metadata.
 */
export class GpuWarmupService {
  private endpoint: string;

  constructor(endpoint = '/gpu/warm') {
    this.endpoint = endpoint;
  }

  /**
   * Request GPU instances to warm up. Resolves immediately — failures are
   * logged but never surfaced to the caller.
   */
  async warmup(authToken?: string, desiredCapacity?: number): Promise<void> {
    try {
      const body: Record<string, number> = {};
      if (desiredCapacity !== undefined) {
        body.desiredCapacity = desiredCapacity;
      }

      await axios.post(this.endpoint, body, {
        timeout: 5000,
        headers: authToken
          ? { Authorization: `Bearer ${authToken}` }
          : undefined,
      });

      logger.info('gpu-warmup-requested', { desiredCapacity });
    } catch (err: unknown) {
      logger.warn('gpu-warmup-failed', { err });
    }
  }
}

export const gpuWarmupService = new GpuWarmupService();
